
<div *ngIf="selectedManagementTeamId" class="yomi-table-area">
  <ng-content
    *ngTemplateOutlet="
      table_templateSalesAmountForTeam;
      context: {
        collection: salesForSelectedTeam,
        summaries: salesSummaryForSelectedTeam
      }
    "
  >
  </ng-content>
</div>
<div *ngIf="!selectedManagementTeamId" class="yomi-table-area">
  <ng-content
    *ngTemplateOutlet="
      table_templateSalesAmount;
      context: {
        collection: salesForSelectedUser,
        summary: salesSummaryForSelectedUser
      }
    "
  >
  </ng-content>
</div>

<ng-template
  #currencyCell
  let-isYomi="isYomi"
  let-isSK="isSK"
  let-value="currency"
  let-unitLabel="unitLabel"
  let-rightBorder="rightBorder"
  let-truncateUnderThousand="truncateUnderThousand"
>
  <td
    class="currency currency__clickable"
    [ngClass]="{ 'neg-value': value < 0, 'pos-value': value > 0, 'sk': isSK, 'yomi': isYomi, 'right-border': rightBorder }"
  >
    <span *ngIf="!value && value !== 0">-</span>
    <span *ngIf="value || value === 0">
      {{
        formatCurrency(
          value,
          truncateUnderThousand
        ) | undef | number: "0.0-2"
      }}
    </span>
    {{unitLabel}}
  </td>
</ng-template>

<ng-template
  #headerTemplateSalesAmount
  let-isTeam="isTeam"
  let-teamInfo="teamInfo"
>
  <thead>
    <tr>
      <th class="yomi right-border" *ngIf="isTeam">{{teamInfo && teamInfo.name}}</th>
      <th class="yomi right-border" *ngIf="isTeam">SN目標</th>
      <th>SN</th>
      <th class="yomi">カタ</th>
      <th class="yomi">FCST</th>
      <th class="yomi">★</th>
      <th class="yomi">ノビ</th>
      <th class="yomi">達成率</th>
      <th class="yomi right-border">理論値</th>
      <th class="yomi right-border" *ngIf="isTeam">GK目標</th>
      <th>SK</th>
      <th class="yomi">カタ</th>
      <th class="yomi">FCST</th>
      <th class="yomi">★</th>
      <th class="yomi">ノビ</th>
      <th class="yomi">達成率</th>
      <th class="yomi right-border">理論値</th>
      <th class="yomi right-border">SK残</th>
      <th>Cancel(SN)</th>
      <th>Cancel(SK)</th>
    </tr>
  </thead>
</ng-template>

<ng-template
  #table_templateSalesAmount
  let-collection="collection"
  let-summary="summary"
>
  <table *ngIf="collection">
    <ng-content *ngTemplateOutlet="headerTemplateSalesAmount"></ng-content>
    <tbody>
      <tr>
        <ng-container>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.sn
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.snKata,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.snFCST,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.snHoshi,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.snNobi,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summary.snTargetAchievementRate,
                unitLabel: '%'
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.snYomi3ProbabilitySum,
                rightBorder: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.sk,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.skKata,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.skFCST,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.skHoshi,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.skNobi,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summary.skTargetAchievementRate,
                unitLabel: '%'
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.skYomi3ProbabilitySum,
                rightBorder: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summary.skGapWithTarget,
                rightBorder: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.cancelSn
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: collection.cancel,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
        </ng-container>
      </tr>
    </tbody>
  </table>
</ng-template>

<ng-template
  #table_templateSalesAmountForTeam
  let-collection="collection"
  let-summaries="summaries"
>
  <table *ngIf="collection.total">
    <ng-content
      *ngTemplateOutlet="headerTemplateSalesAmount;
      context:{
        isTeam: true,
        teamInfo: userTeamInjector.getTeamInfoById(selectedManagementTeamId) | async
      }"
    ></ng-content>
    <tbody>
      <tr *ngFor="let row of collection.users">
        <ng-container
          *appLet="
            (summaries.users[row.userId] || {}) as summaryRow
          "
        >
          <ng-container
            *ngIf="
              userTeamInjector.getUserTeamInfoById(row.userId) | async as user
            "
          >
            <td class="right-border">{{ user.name }}</td>
          </ng-container>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summaryRow.snTarget,
                rightBorder: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.sn
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snKata,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snFCST,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snHoshi,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snNobi,
                isYomi: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summaryRow.snTargetAchievementRate,
                isYomi: true,
                unitLabel: '%'
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.snYomi3ProbabilitySum,
                isYomi: true,
                rightBorder: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summaryRow.gkTarget,
                rightBorder: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.sk,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skKata,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skFCST,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skHoshi,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skNobi,
                isYomi: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summaryRow.skTargetAchievementRate,
                isYomi: true,
                unitLabel: '%'
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.skYomi3ProbabilitySum,
                isYomi: true,
                rightBorder: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: summaryRow.skGapWithTarget,
                isYomi: true,
                rightBorder: true,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.cancelSn
              }
            "
          ></ng-content>
          <ng-content
            *ngTemplateOutlet="
              currencyCell;
              context: {
                currency: row.cancel,
                truncateUnderThousand: true,
                isSK: true
              }
            "
          ></ng-content>
        </ng-container>
      </tr>
      <tr class="total">
        <td class="label right-border">合計</td>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: summaries.total?.snTarget, rightBorder: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.sn }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.snKata, isYomi: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.snFCST, isYomi: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.snHoshi, isYomi: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.snNobi, isYomi: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: summaries.total?.snTargetAchievementRate, isYomi: true, unitLabel: '%'  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.snYomi3ProbabilitySum, isYomi: true, rightBorder: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: summaries.total?.gkTarget, rightBorder: true, isSK: true, truncateUnderThousand: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.sk, isSK: true, truncateUnderThousand: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.skKata, isYomi: true, isSK: true, truncateUnderThousand: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.skFCST, isYomi: true, isSK: true, truncateUnderThousand: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.skHoshi, isYomi: true, isSK: true, truncateUnderThousand: true  }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.skNobi, isYomi: true, isSK: true, truncateUnderThousand: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: summaries.total?.skTargetAchievementRate, isYomi: true, unitLabel: '%' }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: collection.total?.skYomi3ProbabilitySum, isYomi: true, rightBorder: true, isSK: true, truncateUnderThousand: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: { currency: summaries.total?.skGapWithTarget, isYomi: true, rightBorder: true, isSK: true, truncateUnderThousand: true }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: {
              currency: collection.total?.cancelSn
            }
          "
        ></ng-content>
        <ng-content
          *ngTemplateOutlet="
            currencyCell;
            context: {
              currency: collection.total?.cancel,
              isSK: true,
              truncateUnderThousand: true
            }
          "
        ></ng-content>
      </tr>
    </tbody>
  </table>
</ng-template>
